import axios from "@/api/axiosInstance";
import { FetchProductCatalogDirectoryResponse } from "./types";

export const fetchProductCatalogDirectory = async (
  signal?: AbortSignal,
): Promise<FetchProductCatalogDirectoryResponse> => {
  const response = await axios.get<FetchProductCatalogDirectoryResponse>(
    "/api/private/product-catalog/directory",
    { signal },
  );
  return response.data;
};
